"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[717],{

/***/ 2422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ isIFrameWindow; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
function isIFrameWindow(windowObject) {
  if (!windowObject) return false;
  return windowObject.self !== windowObject.top;
}

/***/ }),

/***/ 3403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ applyFnToProps; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Applies a function to properties of a specified type in an object, recursively.
 *
 * @param {Object} obj - The object to apply the function to.
 * @param {Function} fn - The function to apply to matching properties.
 * @param {string} [type='string'] - The type of properties to apply the function to.
 * @param {Array<string>} [ignoreKeys=[]] - The keys of properties to ignore and not modify.
 * @returns {Object} - The object with function recursively applied.
 */
function applyFnToProps(obj, fn, type = 'string', ignoreKeys = []) {
  if (!obj || typeof obj !== 'object') return obj;
  Object.keys(obj).forEach(property => {
    if (typeof obj[property] === 'object') {
      applyFnToProps(obj[property], fn, type, ignoreKeys);
    } else {
      // eslint-disable-next-line valid-typeof
      if (typeof obj[property] === type && !ignoreKeys.includes(property)) obj[property] = fn(obj[property]);
    }
  });
  return obj;
}

/***/ }),

/***/ 1731:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ isPureObject; }
/* harmony export */ });
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Tests a passed object to see if it is a pure object or not. All non-primatives in JS
 * are technically objects and would pass a `typeof` check.
 * @param {*} obj Input object to be tested
**/
function isPureObject(obj) {
  return obj?.constructor === {}.constructor;
}

/***/ }),

/***/ 7019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Aggregate": function() { return /* binding */ Aggregate; }
});

// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/stringify.js
var stringify = __webpack_require__(4155);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/url/clean-url.js
var clean_url = __webpack_require__(1478);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/generic_events/constants.js
var constants = __webpack_require__(8089);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/constants/runtime.js
var runtime = __webpack_require__(9152);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/utils/aggregate-base.js + 7 modules
var aggregate_base = __webpack_require__(7410);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/console.js
var console = __webpack_require__(1639);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/timing/now.js
var now = __webpack_require__(1595);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/event-emitter/register-handler.js
var register_handler = __webpack_require__(5992);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/metrics/constants.js + 1 modules
var metrics_constants = __webpack_require__(3705);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/traverse.js
var traverse = __webpack_require__(3403);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/dom/selector-path.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Generates a CSS selector path for the given element, if possible
 * @param {HTMLElement} elem
 * @param {boolean} includeId
 * @param {boolean} includeClass
 * @returns {string|undefined}
 */
const generateSelectorPath = (elem, targetFields = []) => {
  if (!elem) return {
    path: undefined,
    nearestFields: {}
  };
  const getNthOfTypeIndex = node => {
    try {
      let i = 1;
      const {
        tagName
      } = node;
      while (node.previousElementSibling) {
        if (node.previousElementSibling.tagName === tagName) i++;
        node = node.previousElementSibling;
      }
      return i;
    } catch (err) {
      // do nothing for now.  An invalid child count will make the path selector not return a nth-of-type selector statement
    }
  };
  let pathSelector = '';
  let index = getNthOfTypeIndex(elem);
  const nearestFields = {};
  try {
    while (elem?.tagName) {
      const {
        id,
        localName
      } = elem;
      targetFields.forEach(field => {
        nearestFields[nearestAttrName(field)] ||= elem[field];
      });
      const selector = [localName, id ? "#".concat(id) : '', pathSelector ? ">".concat(pathSelector) : ''].join('');
      pathSelector = selector;
      elem = elem.parentNode;
    }
  } catch (err) {
    // do nothing for now
  }
  const path = pathSelector ? index ? "".concat(pathSelector, ":nth-of-type(").concat(index, ")") : pathSelector : undefined;
  return {
    path,
    nearestFields
  };
  function nearestAttrName(originalFieldName) {
    /** preserve original renaming structure for pre-existing field maps */
    if (originalFieldName === 'tagName') originalFieldName = 'tag';
    if (originalFieldName === 'className') originalFieldName = 'class';
    return "nearest".concat(originalFieldName.charAt(0).toUpperCase() + originalFieldName.slice(1));
  }
};
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/generic_events/aggregate/user-actions/aggregated-user-action.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */

class AggregatedUserAction {
  constructor(evt, selectorPath, nearestTargetFields) {
    this.event = evt;
    this.count = 1;
    this.originMs = Math.floor(evt.timeStamp);
    this.relativeMs = [0];
    this.selectorPath = selectorPath;
    this.rageClick = undefined;
    this.nearestTargetFields = nearestTargetFields;
  }

  /**
   * Aggregates the count and maintains the relative MS array for matching events
   * Will determine if a rage click was observed as part of the aggregation
   * @param {Event} evt
   * @returns {void}
   */
  aggregate(evt) {
    this.count++;
    this.relativeMs.push(Math.floor(evt.timeStamp - this.originMs));
    if (this.isRageClick()) this.rageClick = true;
  }

  /**
   * Determines if the current set of relative ms values constitutes a rage click
   * @returns {boolean}
   */
  isRageClick() {
    const len = this.relativeMs.length;
    return this.event.type === 'click' && len >= constants/* RAGE_CLICK_THRESHOLD_EVENTS */.lj && this.relativeMs[len - 1] - this.relativeMs[len - constants/* RAGE_CLICK_THRESHOLD_EVENTS */.lj] < constants/* RAGE_CLICK_THRESHOLD_MS */.LV;
  }
}
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/generic_events/aggregate/user-actions/user-actions-aggregator.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */



class UserActionsAggregator {
  /** @type {AggregatedUserAction=} */
  #aggregationEvent = undefined;
  #aggregationKey = '';
  get aggregationEvent() {
    // if this is accessed externally, we need to be done aggregating on it
    // to prevent potential mutability and duplication issues, so the state is cleared upon returning.
    // This value may need to be accessed during an unload harvest.
    const finishedEvent = this.#aggregationEvent;
    this.#aggregationKey = '';
    this.#aggregationEvent = undefined;
    return finishedEvent;
  }

  /**
   * Process the event and determine if a new aggregation set should be made or if it should increment the current aggregation
   * @param {Event} evt The event supplied by the addEventListener callback
   * @returns {AggregatedUserAction|undefined} The previous aggregation set if it has been completed by processing the current event
   */
  process(evt, targetFields) {
    if (!evt) return;
    const {
      selectorPath,
      nearestTargetFields
    } = getSelectorPath(evt, targetFields);
    const aggregationKey = getAggregationKey(evt, selectorPath);
    if (!!aggregationKey && aggregationKey === this.#aggregationKey) {
      // an aggregation exists already, so lets just continue to increment
      this.#aggregationEvent.aggregate(evt);
    } else {
      // return the prev existing one (if there is one)
      const finishedEvent = this.#aggregationEvent;
      // then set as this new event aggregation
      this.#aggregationKey = aggregationKey;
      this.#aggregationEvent = new AggregatedUserAction(evt, selectorPath, nearestTargetFields);
      return finishedEvent;
    }
  }
}

/**
 * Generates a selector path for the event, starting with simple cases like window or document and getting more complex for dom-tree traversals as needed.
 * Will return a random selector path value if no other path can be determined, to force the aggregator to skip aggregation for this event.
 * @param {Event} evt
 * @returns {string}
 */
function getSelectorPath(evt, targetFields) {
  let selectorPath;
  let nearestTargetFields = {};
  if (constants/* OBSERVED_WINDOW_EVENTS.includes */.jC.includes(evt.type) || evt.target === window) selectorPath = 'window';else if (evt.target === document) selectorPath = 'document';
  // if still no selectorPath, generate one from target tree that includes elem ids
  else {
    const {
      path,
      nearestFields
    } = generateSelectorPath(evt.target, targetFields);
    selectorPath = path;
    nearestTargetFields = nearestFields;
  }
  // if STILL no selectorPath, it will return undefined which will skip aggregation for this event
  return {
    selectorPath,
    nearestTargetFields
  };
}

/**
 * Returns an aggregation key based on the event type and the selector path of the event's target.
 * Scrollend events are aggregated into one set, no matter what.
 * @param {Event} evt
 * @param {string} selectorPath
 * @returns {string}
 */
function getAggregationKey(evt, selectorPath) {
  let aggregationKey = evt.type;
  /** aggregate all scrollends into one set (if sequential), no matter what their target is
   * the aggregation group's selector path with be reflected as the first one observed
   * due to the way the aggregation logic works (by storing the initial value and aggregating it) */
  if (evt.type !== 'scrollend') aggregationKey += '-' + selectorPath;
  return aggregationKey;
}
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/dom/iframe.js
var iframe = __webpack_require__(2422);
// EXTERNAL MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/common/util/type-check.js
var type_check = __webpack_require__(1731);
;// CONCATENATED MODULE: ./node_modules/@newrelic/browser-agent/dist/esm/features/generic_events/aggregate/index.js
/**
 * Copyright 2020-2025 New Relic, Inc. All rights reserved.
 * SPDX-License-Identifier: Apache-2.0
 */













class Aggregate extends aggregate_base/* AggregateBase */.m {
  static featureName = constants/* FEATURE_NAME */.t9;
  constructor(agentRef) {
    super(agentRef, constants/* FEATURE_NAME */.t9);
    this.eventsPerHarvest = 1000;
    this.referrerUrl = runtime/* isBrowserScope */.il && document.referrer ? (0,clean_url/* cleanURL */.f)(document.referrer) : undefined;
    this.waitForFlags(['ins']).then(([ins]) => {
      if (!ins) {
        this.blocked = true;
        this.deregisterDrain();
        return;
      }
      this.trackSupportabilityMetrics();
      (0,register_handler/* registerHandler */.X)('api-recordCustomEvent', (timestamp, eventType, attributes) => {
        if (constants/* RESERVED_EVENT_TYPES.includes */.J2.includes(eventType)) return (0,console/* warn */.Z)(46);
        this.addEvent({
          eventType,
          timestamp: this.toEpoch(timestamp),
          ...attributes
        });
      }, this.featureName, this.ee);
      if (agentRef.init.page_action.enabled) {
        (0,register_handler/* registerHandler */.X)('api-addPageAction', (timestamp, name, attributes) => {
          this.addEvent({
            ...attributes,
            eventType: 'PageAction',
            timestamp: this.toEpoch(timestamp),
            timeSinceLoad: timestamp / 1000,
            actionName: name,
            referrerUrl: this.referrerUrl,
            ...(runtime/* isBrowserScope */.il && {
              browserWidth: window.document.documentElement?.clientWidth,
              browserHeight: window.document.documentElement?.clientHeight
            })
          });
        }, this.featureName, this.ee);
      }
      let addUserAction = () => {/** no-op */};
      if (runtime/* isBrowserScope */.il && agentRef.init.user_actions.enabled) {
        this.userActionAggregator = new UserActionsAggregator();
        this.harvestOpts.beforeUnload = () => addUserAction?.(this.userActionAggregator.aggregationEvent);
        addUserAction = aggregatedUserAction => {
          try {
            /** The aggregator process only returns an event when it is "done" aggregating -
             * so we still need to validate that an event was given to this method before we try to add */
            if (aggregatedUserAction?.event) {
              const {
                target,
                timeStamp,
                type
              } = aggregatedUserAction.event;
              this.addEvent({
                eventType: 'UserAction',
                timestamp: this.toEpoch(timeStamp),
                action: type,
                actionCount: aggregatedUserAction.count,
                actionDuration: aggregatedUserAction.relativeMs[aggregatedUserAction.relativeMs.length - 1],
                actionMs: aggregatedUserAction.relativeMs,
                rageClick: aggregatedUserAction.rageClick,
                target: aggregatedUserAction.selectorPath,
                ...((0,iframe/* isIFrameWindow */.u)(window) && {
                  iframe: true
                }),
                ...this.agentRef.init.user_actions.elementAttributes.reduce((acc, field) => {
                  /** prevent us from capturing an obscenely long value */
                  if (canTrustTargetAttribute(field)) acc[targetAttrName(field)] = String(target[field]).trim().slice(0, 128);
                  return acc;
                }, {}),
                ...aggregatedUserAction.nearestTargetFields
              });

              /**
               * Returns the original target field name with `target` prepended and camelCased
               * @param {string} originalFieldName
               * @returns {string} the target field name
               */
              function targetAttrName(originalFieldName) {
                /** preserve original renaming structure for pre-existing field maps */
                if (originalFieldName === 'tagName') originalFieldName = 'tag';
                if (originalFieldName === 'className') originalFieldName = 'class';
                /** return the original field name, cap'd and prepended with target to match formatting */
                return "target".concat(originalFieldName.charAt(0).toUpperCase() + originalFieldName.slice(1));
              }

              /**
               * Only trust attributes that exist on HTML element targets, which excludes the window and the document targets
               * @param {string} attribute The attribute to check for on the target element
               * @returns {boolean} Whether the target element has the attribute and can be trusted
               */
              function canTrustTargetAttribute(attribute) {
                return !!(aggregatedUserAction.selectorPath !== 'window' && aggregatedUserAction.selectorPath !== 'document' && target instanceof HTMLElement && target?.[attribute]);
              }
            }
          } catch (e) {
            // do nothing for now
          }
        };
        (0,register_handler/* registerHandler */.X)('ua', evt => {
          /** the processor will return the previously aggregated event if it has been completed by processing the current event */
          addUserAction(this.userActionAggregator.process(evt, this.agentRef.init.user_actions.elementAttributes));
        }, this.featureName, this.ee);
      }

      /**
       * is it worth complicating the agent and skipping the POs for single repeating queries? maybe,
       * but right now it was less desirable simply because it is a nice benefit of populating the event buffer
       * immediately as events happen for payload evaluation purposes and that becomes a little more chaotic
       * with an arbitrary query method. note: eventTypes: [...types] does not support the 'buffered' flag so we have
       * to create up to two PO's here.
       */
      const performanceTypesToCapture = [...(agentRef.init.performance.capture_marks ? ['mark'] : []), ...(agentRef.init.performance.capture_measures ? ['measure'] : [])];
      if (performanceTypesToCapture.length) {
        try {
          performanceTypesToCapture.forEach(type => {
            if (PerformanceObserver.supportedEntryTypes.includes(type)) {
              const observer = new PerformanceObserver(list => {
                list.getEntries().forEach(entry => {
                  try {
                    this.reportSupportabilityMetric('Generic/Performance/' + type + '/Seen');
                    const detailObj = agentRef.init.performance.capture_detail ? createDetailAttrs(entry.detail) : {};
                    this.addEvent({
                      ...detailObj,
                      eventType: 'BrowserPerformance',
                      timestamp: this.toEpoch(entry.startTime),
                      entryName: (0,clean_url/* cleanURL */.f)(entry.name),
                      entryDuration: entry.duration,
                      entryType: type
                    });
                    function createDetailAttrs(detail) {
                      if (detail === null || detail === undefined) return {};else if (!(0,type_check/* isPureObject */.S)(detail)) return {
                        entryDetail: detail
                      };else return flattenJSON(detail);
                      function flattenJSON(nestedJSON, parentKey = 'entryDetail') {
                        let items = {};
                        if (nestedJSON === null || nestedJSON === undefined) return items;
                        Object.keys(nestedJSON).forEach(key => {
                          let newKey = parentKey + '.' + key;
                          if ((0,type_check/* isPureObject */.S)(nestedJSON[key])) {
                            Object.assign(items, flattenJSON(nestedJSON[key], newKey));
                          } else {
                            if (nestedJSON[key] !== null && nestedJSON[key] !== undefined) items[newKey] = nestedJSON[key];
                          }
                        });
                        return items;
                      }
                    }
                  } catch (err) {}
                });
              });
              observer.observe({
                buffered: true,
                type
              });
            }
          });
        } catch (err) {
          // Something failed in our set up, likely the browser does not support PO's... do nothing
        }
      }
      if (runtime/* isBrowserScope */.il && agentRef.init.performance.resources.enabled) {
        (0,register_handler/* registerHandler */.X)('browserPerformance.resource', entry => {
          try {
            // convert the entry to a plain object and separate the name and duration from the object
            // you need to do this to be able to spread it into the addEvent call later, and name and duration
            // would be duplicative of entryName and entryDuration and are protected keys in NR1
            const {
              name,
              duration,
              ...entryObject
            } = entry.toJSON();
            let firstParty = false;
            try {
              const entryDomain = new URL(name).hostname;
              const isNr = entryDomain.includes('newrelic.com') || entryDomain.includes('nr-data.net') || entryDomain.includes('nr-local.net');
              /** decide if we should ignore nr-specific assets */
              if (this.agentRef.init.performance.resources.ignore_newrelic && isNr) return;
              /** decide if we should ignore the asset type (empty means allow everything, which is the default) */
              if (this.agentRef.init.performance.resources.asset_types.length && !this.agentRef.init.performance.resources.asset_types.includes(entryObject.initiatorType)) return;
              /** decide if the entryDomain is a first party domain */
              firstParty = entryDomain === runtime/* globalScope */._A?.location.hostname || agentRef.init.performance.resources.first_party_domains.includes(entryDomain);
              if (firstParty) this.reportSupportabilityMetric('Generic/Performance/FirstPartyResource/Seen');
              if (isNr) this.reportSupportabilityMetric('Generic/Performance/NrResource/Seen');
            } catch (err) {
              // couldnt parse the URL, so firstParty will just default to false
            }
            this.reportSupportabilityMetric('Generic/Performance/Resource/Seen');
            const event = {
              ...entryObject,
              eventType: 'BrowserPerformance',
              timestamp: Math.floor(agentRef.runtime.timeKeeper.correctRelativeTimestamp(entryObject.startTime)),
              entryName: name,
              entryDuration: duration,
              firstParty
            };
            this.addEvent(event);
          } catch (err) {
            this.ee.emit('internal-error', [err, 'GenericEvents-Resource']);
          }
        }, this.featureName, this.ee);
      }
      agentRef.runtime.harvester.triggerHarvestFor(this);
      this.drain();
    });
  }

  // WARNING: Insights times are in seconds. EXCEPT timestamp, which is in ms.
  /** Some keys are set by the query params or request headers sent with the harvest and override the body values, so check those before adding new standard body values...
   * see harvest.js#baseQueryString for more info on the query params
   * Notably:
   * * name: set by the `t=` query param
   * * appId: set by the `a=` query param
   * * standalone: set by the `sa=` query param
   * * session: set by the `s=` query param
   * * sessionTraceId: set by the `ptid=` query param
   * * userAgent*: set by the userAgent header
   * @param {object=} obj the event object for storing in the event buffer
   * @returns void
   */
  addEvent(obj = {}) {
    if (!obj || !Object.keys(obj).length) return;
    if (!obj.eventType) {
      (0,console/* warn */.Z)(44);
      return;
    }
    for (let key in obj) {
      let val = obj[key];
      obj[key] = val && typeof val === 'object' ? (0,stringify/* stringify */.P)(val) : val;
    }
    const defaultEventAttributes = {
      /** should be overridden by the event-specific attributes, but just in case -- set it to now() */
      timestamp: Math.floor(this.agentRef.runtime.timeKeeper.correctRelativeTimestamp((0,now/* now */.z)())),
      /** all generic events require pageUrl(s) */
      pageUrl: (0,clean_url/* cleanURL */.f)('' + runtime/* initialLocation */.FN),
      currentUrl: (0,clean_url/* cleanURL */.f)('' + location)
    };
    const eventAttributes = {
      /** Agent-level custom attributes */
      ...(this.agentRef.info.jsAttributes || {}),
      /** Fallbacks for required properties in-case the event did not supply them, should take precedence over agent-level custom attrs */
      ...defaultEventAttributes,
      /** Event-specific attributes take precedence over agent-level custom attributes and fallbacks */
      ...obj
    };
    const addedEvent = this.events.add(eventAttributes);
    if (!addedEvent && !this.events.isEmpty()) {
      /** could not add the event because it pushed the buffer over the limit
       * so we harvest early, and try to add it again now that the buffer is cleared
       * if it fails again, we do nothing
       */
      this.ee.emit(metrics_constants/* SUPPORTABILITY_METRIC_CHANNEL */.xS, ['GenericEvents/Harvest/Max/Seen']);
      this.agentRef.runtime.harvester.triggerHarvestFor(this);
      this.events.add(eventAttributes);
    }
  }
  serializer(eventBuffer) {
    return (0,traverse/* applyFnToProps */.R)({
      ins: eventBuffer
    }, this.obfuscator.obfuscateString.bind(this.obfuscator), 'string');
  }
  queryStringsBuilder() {
    return {
      ua: this.agentRef.info.userAttributes,
      at: this.agentRef.info.atts
    };
  }
  toEpoch(timestamp) {
    return Math.floor(this.agentRef.runtime.timeKeeper.correctRelativeTimestamp(timestamp));
  }
  trackSupportabilityMetrics() {
    /** track usage SMs to improve these experimental features */
    const configPerfTag = 'Config/Performance/';
    if (this.agentRef.init.performance.capture_marks) this.reportSupportabilityMetric(configPerfTag + 'CaptureMarks/Enabled');
    if (this.agentRef.init.performance.capture_measures) this.reportSupportabilityMetric(configPerfTag + 'CaptureMeasures/Enabled');
    if (this.agentRef.init.performance.resources.enabled) this.reportSupportabilityMetric(configPerfTag + 'Resources/Enabled');
    if (this.agentRef.init.performance.resources.asset_types?.length !== 0) this.reportSupportabilityMetric(configPerfTag + 'Resources/AssetTypes/Changed');
    if (this.agentRef.init.performance.resources.first_party_domains?.length !== 0) this.reportSupportabilityMetric(configPerfTag + 'Resources/FirstPartyDomains/Changed');
    if (this.agentRef.init.performance.resources.ignore_newrelic === false) this.reportSupportabilityMetric(configPerfTag + 'Resources/IgnoreNewrelic/Changed');
  }
}

/***/ })

}]);